import React from 'react'
import { Control, Controller } from 'react-hook-form'
import FormControl from '@mui/material/FormControl'
import { InputLabel, Select, MenuItem, FormHelperText, SelectProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

type Item = {
  label: string
  value: number | string
}

type Props = SelectProps & {
  name: string
  control: Control | any
  errorMessage?: string | null
  label?: string
  items: Item[]
  value?: string
}

export function FormInputSelect ({ name, control, label, errorMessage, items, value, ...rest }: Props) {
  const { t } = useTranslation()
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={(items.find(columns => columns?.value === value)) ? value : undefined}
      render={({ field: { onChange, value }, fieldState: { invalid } }) =>
        <FormControl fullWidth error={invalid}>
          <InputLabel>{label}</InputLabel>
          <Select
            {...rest}
            value={value || ''}
            label={label}
            onChange={onChange}
          >
            {items?.map(({ label, value }, key) =>
              <MenuItem value={value} key={key}>{t(label)}</MenuItem>
            )}
          </Select>
          {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
        </FormControl>
      } />
  )
}
